var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--select",style:({
    '--form-item-width': _vm.grid.Cols,
    '--form-item-height': _vm.grid.Rows,
    '--form-item-start': _vm.grid.Offset,
    display: 'flex',
    justifyContent: 'flex-start'
  })},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.Key + button.Value,class:['button', button.Color],attrs:{"disabled":_vm.isDisabled(button)},on:{"click":function($event){$event.preventDefault();return _vm.onClick(button)}}},[_vm._v(" "+_vm._s(button.Title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }